"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _toConsumableArray2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _booking = require("@/api/bookSpace/booking");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    preLockFlag: {
      type: Boolean,
      default: null
    },
    isDisable: {
      type: Boolean,
      required: false,
      default: false
    },
    formMain: {
      type: Object
    },
    containerTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      locationList: [],
      vgmScaleList: [],
      form: {
        formVgm: [],
        deleteVgmList: []
      },
      rules: {
        vesselCode: [{
          required: true,
          trigger: 'blur'
        }],
        voyageNo: [{
          required: true,
          trigger: 'blur'
        }],
        voyageLeg: [{
          required: true,
          trigger: 'blur'
        }],
        bkNo: [{
          required: true,
          trigger: 'blur'
        }],
        blNo: [{
          required: true,
          trigger: 'blur'
        }],
        containerNo: [{
          required: true,
          trigger: 'blur'
        }],
        containerType: [{
          required: true,
          trigger: 'change'
        }],
        vgmMethod: [{
          required: true,
          trigger: 'change'
        }],
        vgmGrossWeight: [{
          required: true,
          trigger: 'change'
        }],
        vgmScale: [{
          required: true,
          trigger: 'blur'
        }]
        // vgmDate: [ { required: true, trigger: 'blur' }],
        // location: [ { required: true, trigger: 'blur' }],
        // remark: [ { required: true, trigger: 'blur' }],
        // shipperOther: [ { required: true, trigger: 'blur' }],
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  created: function created() {
    var _this = this;
    this.$dictionary.get(['VGM_METHOD', 'GT_WEIGHT_SCALE'], true).then(function (res) {
      res = JSON.parse(JSON.stringify(res));
      _this.locationList = res.VGM_METHOD;
      _this.vgmScaleList = res.GT_WEIGHT_SCALE;
    });
  },
  methods: {
    // 改变单位
    handleChangeVgmMethod: function handleChangeVgmMethod(val, item, index) {
      var _this2 = this;
      if (val === 2) {
        if (item.weight && item.containerType) {
          var data = {
            containerType: item.containerType,
            vgmGrossWeight: String(item.weight)
          };
          (0, _booking.getVgmContainerWeight)(data).then(function (res) {
            _this2.$set(_this2.form.formVgm[index], 'vgmScale', 1);
            _this2.$set(_this2.form.formVgm[index], 'vgmGrossWeight', res.data);
            _this2.$forceUpdate();
          });
        }
      }
    },
    handleLoadBkVgmContainers: function handleLoadBkVgmContainers() {
      var _this3 = this;
      var data = {
        bkNo: this.formMain.bkNo,
        blNo: this.formMain.blNo
      };
      (0, _booking.loadBkVgmContainers)(data).then(function (res) {
        if (_this3.form.formVgm.length === 0) {
          _this3.form.formVgm = res.data || [];
        }
      });
    },
    handleSubimt: function handleSubimt() {
      var _this4 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this4.$parent.vgMDialogDialogVisible = false;
        }
      });
    },
    handleSubimtSign: function handleSubimtSign() {
      this.$parent.vgMDialogDialogVisible = false;
    },
    handleAddCharge: function handleAddCharge() {
      console.log(this.form.formVgm, this.formMain, 'this.formMain.webBkContainerComs');
      this.form.formVgm.push({
        vesselCode: this.formMain.vesselCode,
        voyageNo: this.formMain.voyageNo,
        voyageLeg: this.formMain.voyageLeg,
        bkNo: this.formMain.bkNo,
        blNo: this.formMain.blNo,
        containerNo: '',
        location: '',
        vgmGrossWeight: '',
        vgmScale: '',
        vgmDate: '',
        remark: '',
        shipperOther: '',
        shipperVgmPersonSig: '',
        containerType: '',
        vgmMethod: '',
        rowStatus: 4,
        weight: null //箱信息的毛重
      });
    },
    handleRemoveCharge: function handleRemoveCharge(row, index) {
      console.log(row, index, '删除1');
      if (row.bkVgmContainerId) {
        console.log(row, index, '删除2');
        row.rowStatus = 8;
        this.form.deleteVgmList.push(row);
      }
      this.form.formVgm.splice(index, 1);
    },
    handleOpenOne: function handleOpenOne(item) {
      var link = document.createElement('a');
      link.href = item; // 指向你的 Word 文档路径
      if (item === '/static/doc/VGMONE.doc') {
        link.download = this.$t('home.titleOne'); // 设置下载文件名
      } else {
        link.download = this.$t('home.titleTwo'); // 设置下载文件名
      }
      link.click(); // 触发点击事件
    },
    handleAddChargeTobu: function handleAddChargeTobu() {
      var _this5 = this;
      this.form.formVgm = [];
      var dataArr = this.formMain.webBkContainerComs.map(function (item) {
        return {
          vesselCode: _this5.formMain.vesselCode,
          voyageNo: _this5.formMain.voyageNo,
          voyageLeg: _this5.formMain.voyageLeg,
          containerNo: item.containerNo,
          bkNo: _this5.formMain.bkNo,
          blNo: _this5.formMain.blNo,
          vgmMethod: 2,
          containerType: item.containerType,
          rowStatus: 4,
          weight: item.weight,
          vgmGrossWeight: '',
          vgmScale: ''
        };
      });
      if (this.formMain.pol === 'CNTAO') {
        this.form.formVgm = [].concat((0, _toConsumableArray2.default)(this.form.formVgm), (0, _toConsumableArray2.default)(dataArr));
      } else {
        dataArr.forEach(function (item) {
          if (item.weight && item.containerType) {
            var data = {
              containerType: item.containerType,
              vgmGrossWeight: String(item.weight)
            };
            (0, _booking.getVgmContainerWeight)(data).then(function (res) {
              item.vgmGrossWeight = res.data;
              item.vgmScale = 1;
            });
          }
        });
        this.form.formVgm = [].concat((0, _toConsumableArray2.default)(this.form.formVgm), (0, _toConsumableArray2.default)(dataArr));
      }
    }
  }
};